import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import type { ContactsCountry } from "app/pages/sales-intelligence/modules/company-analysis/types/contacts";
import RegionService from "app/services/RegionService";

import type { ContactsCountryGroup } from "../utils/employeeLocationGroups";
import { buildEmployeeLocationGroups } from "../utils/employeeLocationGroups";

export const useEmployeeLocationGroups = (countries: readonly ContactsCountry[]): ContactsCountryGroup[] => {
    const regions = RegionService.getRegions();
    const otherCountriesLabel = translate("si.lead_gen_filters.countries.other_countries_region");

    return useMemo(
        () => buildEmployeeLocationGroups(countries, regions, otherCountriesLabel),
        [countries, regions, otherCountriesLabel],
    );
};
